import { IMonHoc } from "../../../model/response/category/IMonHoc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eMonHocActionObj = {
    LOAD_START : undefined,
    LOAD_SUCCESS: {} as IMonHoc[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IMonHoc | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IMonHoc,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SAVE_CONG_THUC_START: {} as IMonHoc[],
    SAVE_CONG_THUC_SUCCESS: undefined,
    SAVE_CONG_THUC_ERROR: "",

    UPLOAD_CONG_THUC_MODAL_CLOSE: undefined,
    UPLOAD_CONG_THUC_MODAL_OPEN: undefined,

    CHANGE_CONG_THUC_MON: {id_mon: 0, id_cong_thuc_mon: 0},
}

export const eMonHocActionIds = generateActionTypeIds(eMonHocActionObj,"MON_HOC");

export type IMonHocActionTypes = IGenericActionType<typeof eMonHocActionObj, "MON_HOC">;
